module.exports = __webpack_public_path__ + "img/noComp.09292e76.png";